
import {
    SET_EMAIL_TEMPLATE,
} from './types';

import { apiCallV2, servicesAPICall } from "../../utils/api";


export const SaveEmailTemplate = (et) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "email-template/save",
        {
            ...et,
        },
        localStorage.getItem("access-token"),
    );


    if (res?.data?.data?.success) {
        const { list, count } = getState().EmailTemplate;
        let temp = [...list];

        temp = temp.map((l, i) => {
            return et.id != l.id
                ? l
                : {
                    ...et
                }
        })

        dispatch({
            type: SET_EMAIL_TEMPLATE,
            data: {
                list: temp,
                count: count
            }
        })

        return true;
    } else {
        return false;
    }

}

export const AddNewEmailTemplate = (et) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "email-template/add",
        {
            name: et.name,
            content: et.content,
            emailSubject: et.emailSubject,
            tag: et.tag,
        },
        localStorage.getItem("access-token"),
    );

    if (res?.data?.success) {
        const { list, count } = getState().EmailTemplate;
        let temp = [...list];
        temp.unshift(res?.data?.data);

        dispatch({
            type: SET_EMAIL_TEMPLATE,
            data: {
                list: temp,
                count: count + 1
            }
        })
        return true;
    } else {
        return false;
    }

}

export const GetEmailTemplates = (page, count, filter, sort, isReturn = false) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "email-template/get",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    if (!isReturn) {
        dispatch({
            type: SET_EMAIL_TEMPLATE,
            data: {
                list: res.data.emailTemplates,
                count: res.data.count[0]["count(*)"]
            }
        })
    } else {
        return res.data.emailTemplates;
    }


}

export const SetTemplateDefault = (et) => async (dispatch, getState) => {

    const { list, count } = getState().EmailTemplate;
    let temp = null;
    const updatedList = list.map((l, i) => {
        if (l.id == et.id) {
            temp = {
                ...l,
                is_default: !l.is_default
            };

            apiCallV2(
                "POST",
                "email-template/save",
                {
                    ...temp,
                },
                localStorage.getItem("access-token"),
            );

            return temp;
        } else {
            return l;
        }
    })

    dispatch({
        type: SET_EMAIL_TEMPLATE,
        data: {
            list: updatedList,
            count: count
        }
    })
}

export const ParseHTMLTemplate = (htmlContent) => async (dispatch) => {
    const res = await servicesAPICall(
        "POST",
        "indi-email/parse-html-template",
        {
            htmlContent: htmlContent
        },
        localStorage.getItem("access-token"),
    );

    return {
        success: true
    }

}